import { render, staticRenderFns } from "./DefaultAboutPayment.vue?vue&type=template&id=ed862142&scoped=true&"
import script from "./DefaultAboutPayment.vue?vue&type=script&lang=js&"
export * from "./DefaultAboutPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed862142",
  null
  
)

export default component.exports